import type { TabsState } from "@/context/tabs/types";

export function isAddButtonAllowed(
	tabs: TabsState,
	customTabsLimit: number,
): boolean {
	const predefinedTabs = tabs.filter((tab) => tab.isDefault);

	return tabs.length < predefinedTabs.length + customTabsLimit;
}
